module.exports = __webpack_public_path__ + "media/img/pages/companies/brugg_group-5e3064e6020430ece5915d4d5a2ea3a2.png";